import React, { createContext, useState } from "react";

export const FormErrorContext = createContext<{
  fieldErrors: Record<string, string>;
  setFieldError: (fieldName: string, error: string) => void;
  clearFieldError: (fieldName: string) => void;
}>({
  fieldErrors: {},
  setFieldError: () => {},
  clearFieldError: () => {}
});

export const FormErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  const setFieldError = (fieldName: string, error: string) => {
    setFieldErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const clearFieldError = (fieldName: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setFieldErrors(({ [fieldName]: _, ...rest }) => rest);
  };

  return (
    <FormErrorContext.Provider
      value={{ fieldErrors, setFieldError, clearFieldError }}
    >
      {children}
    </FormErrorContext.Provider>
  );
};
